'use client';

import React, { createContext, useContext } from 'react';

const EditorPreviewContext = createContext(false);

/** Wraps the editor preview's page tree, so shared components can mark their editable elements. */
export const EditorPreviewProvider: React.FC<React.PropsWithChildren> = ({ children }) => (
    <EditorPreviewContext.Provider value={true}>{children}</EditorPreviewContext.Provider>
);

export const useIsEditorPreview = (): boolean => useContext(EditorPreviewContext);

/**
 * The `data-edit-path` attribute, in the preview only. The live page keeps today's DOM.
 */
export function useEditPath(path: string): { 'data-edit-path'?: string } {
    return useIsEditorPreview() ? { 'data-edit-path': path } : {};
}
